import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings($input: NotificationSettingsInput!) {
    updateNotificationSettings(input: $input) {
      success
      error
      notificationSettings {
        id
        portfolioID
        telegramEnabled
        telegramChatID
        emailEnabled
        emailAddress
        exitLevelNotifications
        exitNotifyApproaching
        invalidationNotifications
        invalidationNotifyApproaching
        rapidMoversEnabled
        dailyDigestEnabled
        moverDustThreshold
        moverMaxPositions
        timezone
        dailyDigestHour
        createdAt
        updatedAt
      }
    }
  }
`;

export const DELETE_NOTIFICATION_SETTINGS = gql`
  mutation DeleteNotificationSettings($portfolioID: ID!) {
    deleteNotificationSettings(portfolioID: $portfolioID)
  }
`; 